{
  "nav": "Règles",
  "title": "Règles d’alerte",
  "description": "Une règle surveille une condition et ouvre une alerte quand elle est remplie. Une règle qui se déclenche plus de dix fois en une heure est mise en pause une heure.",
  "loading": "Chargement des règles…",
  "error": "Impossible de charger les règles.",
  "empty": "Aucune règle pour l’instant. Créez-en une pour être prévenu quand quelque chose demande votre attention.",
  "new": "Nouvelle règle",
  "columns": {
    "name": "Règle",
    "condition": "Condition",
    "severity": "Gravité",
    "channels": "Canaux",
    "enabled": "Active",
    "actions": "Actions"
  },
  "enableLabel": "Activer {{name}}",
  "throttled": "En pause jusqu’à {{time}}",
  "edit": "Modifier",
  "editLabel": "Modifier {{name}}",
  "test": "Tester",
  "testLabel": "Tester {{name}}",
  "delete": "Supprimer",
  "deleteLabel": "Supprimer {{name}}",
  "actionFailed": "L’action a échoué.",
  "channels": {
    "in-app": "Dans l’app",
    "desktop": "Bureau",
    "telegram": "Telegram"
  },
  "quietHoursOverride": "Passe outre les heures calmes",
  "summary": {
    "metric": "{{metric}}{{series}} {{operator}} {{value}} sur {{source}}",
    "metricFor": "{{metric}}{{series}} {{operator}} {{value}} pendant {{duration}} sur {{source}}",
    "series": " ({{series}})",
    "eventAny": "tout événement",
    "eventKinds": "événement {{kinds}}",
    "eventSeverity": "gravité ≥ {{severity}}",
    "eventTitle": "titre contenant « {{text}} »",
    "onSource": "sur {{source}}",
    "stale": "{{source}} silencieuse après {{duration}}",
    "absence": "absence de {{kind}} depuis {{duration}} sur {{source}}",
    "unknownSource": "source inconnue"
  },
  "conditionTypes": {
    "metric_threshold": "Seuil sur une métrique",
    "event_match": "Événement correspondant",
    "source_stale": "Source silencieuse",
    "absence": "Absence d’événement"
  },
  "operators": {
    "gt": "supérieur à (>)",
    "gte": "supérieur ou égal à (≥)",
    "lt": "inférieur à (<)",
    "lte": "inférieur ou égal à (≤)"
  },
  "dialog": {
    "titleNew": "Nouvelle règle",
    "titleEdit": "Modifier « {{name}} »",
    "description": "La condition est évaluée toutes les 30 secondes, ou à l’arrivée de chaque événement.",
    "close": "Fermer",
    "name": "Nom",
    "conditionType": "Type de condition",
    "source": "Source",
    "sourcePlaceholder": "Choisir une source…",
    "allSources": "Toutes les sources",
    "operator": "Opérateur",
    "value": "Valeur",
    "forSeconds": "Pendant",
    "forNow": "Immédiatement",
    "kinds": "Types d’événement",
    "kindsHint": "ex. backup.failed, erp.invoice.overdue",
    "minSeverity": "Gravité minimale",
    "anySeverity": "Toutes",
    "titleContains": "Le titre contient",
    "staleAfter": "Silencieuse après (minutes)",
    "kind": "Type d’événement attendu",
    "within": "Attendu au moins toutes les (minutes)",
    "severity": "Gravité de l’alerte",
    "channels": "Canaux",
    "cooldown": "Délai minimum entre deux notifications (minutes)",
    "quietHoursOverride": "Passer outre les heures calmes",
    "quietHoursOverrideHint": "Sévérité critique uniquement : bureau et Telegram sonnent même pendant les heures calmes.",
    "enabled": "Règle active",
    "cancel": "Annuler",
    "create": "Créer la règle",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saveFailed": "Enregistrement impossible. Vérifiez les champs et réessayez.",
    "invalid": "Certains champs sont à corriger."
  },
  "errors": {
    "name": "Donnez un nom à la règle (120 caractères au plus).",
    "sourceId": "Choisissez une source.",
    "metricName": "Choisissez une métrique.",
    "value": "Indiquez une valeur numérique.",
    "kinds": "Vingt types au plus, de 120 caractères chacun.",
    "titleContains": "200 caractères au plus.",
    "staleAfterSeconds": "Entre 1 minute et 7 jours.",
    "kind": "Indiquez le type d’événement attendu.",
    "withinSeconds": "Entre 1 minute et 7 jours.",
    "cooldownS": "Entre 0 et 1 440 minutes.",
    "channels": "Choisissez au moins un canal valide.",
    "other": "Valeur invalide."
  },
  "backtest": {
    "window": "Période testée",
    "days_one": "{{count}} jour",
    "days_other": "{{count}} jours",
    "run_one": "Tester sur {{count}} jour",
    "run_other": "Tester sur {{count}} jours",
    "running": "Test en cours…",
    "fires_zero": "Aucun déclenchement sur la période.",
    "fires_one": "{{count}} déclenchement sur la période.",
    "fires_other": "{{count}} déclenchements sur la période.",
    "samples": "Exemples",
    "unsupported": "Pas d’historique pour ce type de condition : il ne peut pas être rejoué.",
    "failed": "Le test a échoué.",
    "invalid": "Complétez la condition avant de la tester.",
    "titleRule": "Tester « {{name}} »",
    "description": "Rejoue l’historique enregistré pour compter combien de fois la règle se serait déclenchée."
  },
  "confirm": {
    "title": "Supprimer la règle ?",
    "description": "« {{name}} » sera supprimée et ses alertes actives seront résolues.",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "deleting": "Suppression…"
  }
}
